import { render, staticRenderFns } from "./ResourceExpansionPanel.vue?vue&type=template&id=7a775898&"
import script from "./ResourceExpansionPanel.vue?vue&type=script&lang=js&"
export * from "./ResourceExpansionPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports